import * as React from 'react';

import { Container, StyledMarkdown, StyledMenuPosition } from './infoBar.styled';
import { InfoBarProps } from './infoBar.types';

export const InfoBar: React.FC<InfoBarProps> = (props: InfoBarProps) => {
  const { content, internalPath, externalUrl, className }: InfoBarProps = props;

  return (
    <Container className={className}>
      <StyledMenuPosition internalPath={internalPath} externalUrl={externalUrl}>
        <StyledMarkdown text={content} />
      </StyledMenuPosition>
    </Container>
  );
};
